import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import OpsConsolePage from '@/pages/OpsConsolePage';
import AutonomousUWPage from '@/pages/AutonomousUWPage';
import LearningLoopPage from '@/pages/LearningLoopPage';
import BacktestPage from '@/pages/BacktestPage';

export default function AutonomousModule() {
  const tabs = [
    { id: 'day-run', label: 'Day Run', content: <OpsConsolePage /> },
    { id: 'pipeline', label: 'Autonomous Pipeline', content: <AutonomousUWPage /> },
    { id: 'learning', label: 'Learning Loop', content: <LearningLoopPage /> },
    { id: 'backtest', label: 'Model Back-test', content: <BacktestPage /> },
  ];

  return (
    <ModuleShell title="Autonomous Operations" subtitle="One daily cycle, one receipt — intake to renewal, self-tested across every class" tabs={tabs} />
  );
}
